var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"body-1 mb-4 op5 animate__animated animate__slideInLeft animate__faster"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }